<template>
  <div>
    <b-tabs v-model="activeTab">
      <b-tab-item label="Active">
        <div v-if="!trainers">Loading...</div>
        <b-table
          :data="trainers"
          :paginated="trainers.length>5?isPaginated:false"
          :per-page="perPage"
          :loading="$apollo.loading"
          v-if="trainers">
          <template slot-scope="props">
            <b-table-column label="Trainer">
              {{ props.row.name }}
            </b-table-column>
            <b-table-column label="Email">
              {{ props.row.email }}
            </b-table-column>
            <b-table-column label="Phone">
              {{ props.row.phone }}
            </b-table-column>
            <b-table-column label="Registered">
              <template v-if="props.row.user">
                Registered
              </template>
              <template v-else>
                <button class="button is-primary is-outlined" @click="sendTrainerInvite(props.row.id)">Send Sign-Up Invite</button>
              </template>
            </b-table-column>
            <b-table-column  label="Manage">
              <router-link :to="{ name: 'trainerDetails', params: { id: props.row.id } }">View</router-link>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item label="Inactive">
        <b-table
          :data="deactivatedTrainers"
          :paginated="deactivatedTrainers.length>5?isPaginated:false"
          :per-page="perPage"
          :loading="$apollo.loading"
          v-if="deactivatedTrainers">
          <template slot-scope="props">
            <b-table-column label="Trainer">
              {{ props.row.name }}
            </b-table-column>
            <b-table-column label="Email">
              {{ props.row.email }}
            </b-table-column>
            <b-table-column label="Phone">
              {{ props.row.phone }}
            </b-table-column>
            <b-table-column  label="Manage">
              <router-link :to="{ name: 'trainerDetails', params: { id: props.row.id } }">View</router-link>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>

import { deactivatedTrainersQuery, trainersQuery } from '../../graphql/trainers'
import { sendUserInvite } from '../../graphql/users'
import BTableColumn from 'buefy/src/components/table/TableColumn'

export default {
  name: 'TrainersList',
  components: {
    BTableColumn
  },
  data () {
    return {
      activeTab: 0,
      columns: [
        {
          field: 'trainer',
          label: 'Trainer'
        },
        {
          field: 'pendingEarnings',
          label: 'Pending Earnings'
        },
        {
          field: 'totalEarnings',
          label: 'Total Earnings'
        },
        {
          field: 'manage',
          label: 'Manage'
        }
      ],
      isPaginated: true,
      currentPage: 1,
      perPage: 5
    }
  },
  apollo: {
    deactivatedTrainers: {
      query: deactivatedTrainersQuery,
      fetchPolicy: 'network-only'
    },
    trainers: {
      query: trainersQuery,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    sendTrainerInvite (trainerId) {
      this.$apollo.mutate({
        mutation: sendUserInvite,
        variables: {
          trainerId: trainerId
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Invitation Sent!',
            type: 'is-success'
          })
          // refetch the query
          this.$apollo.queries.trainers.refetch()
        })
        .catch((e) => {
          this.$toast.open({
            message: (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
        })
    }
  }
}
</script>
